<template>
	<div class="bgImg registerPage">
		<div class="upper_div"></div>
		<div class="formBox">
			<div class="titleContainer">
				<h1 class="title">רישום לאתר הנדל"ן הממשלתי</h1>
				<p class="plainText">כל המידע על נדל"ן וסביבת המגורים במקום אחד</p>
			</div>
			<div class="formContainer">
				<div class="rowInput">
					<div class="inputContainer">
						<input
							v-model="firstName"
							name="firstName"
							class="genericInput"
							type="text"
							autocomplete="on"
							maxlength="20"
							placeholder="שם פרטי"
							value=""
						/><button class="editBtn"></button>
					</div>
					<div class="inputContainer">
						<input
							v-model="lastName"
							name="lastName"
							class="genericInput"
							type="text"
							autocomplete="on"
							maxlength="30"
							placeholder="שם משפחה"
							value=""
						/><button class="editBtn"></button>
					</div>
				</div>
				<div class="inputContainer">
					<input
						v-model="emailAddress"
						name="emailAddress"
						class="genericInput"
						type="text"
						autocomplete="on"
						maxlength="50"
						placeholder="דואר אלקטרוני"
						value=""
					/><button class="editBtn"></button>
				</div>
				<div class="inputContainer">
					<input
						name="password"
						v-model="password"
						class="genericInput"
						:type="showPassword ? 'text' : 'password'"
						autocomplete="on"
						maxlength="20"
						placeholder="סיסמה"
						value=""
					/>
					<!-- <button class="editBtn"></button> -->
					<!-- <button class="infoBtn" type="button">
				
						
						<div class="popover-body" style="bottom: 70px; width: 200px">
						

						</div>

					</button> -->
					<div class="button-container infoBtn"  style="left: 10px;">
						<button @click="toggleShowPassword()">	
							<!-- <svg class="MuiSvgIcon-root MuiSvgIcon-fontSizeMedium muirtl-wti7xm" focusable="false" aria-hidden="true" viewBox="0 0 24 24"  height="20px"      color="red"
							data-testid="VisibilityOutlinedIcon">
								<path d="M12 6c3.79 0 7.17 2.13 8.82 5.5C19.17 14.87 15.79 17 12 17s-7.17-2.13-8.82-5.5C4.83 8.13 8.21 6 12 6m0-2C7 4 2.73 7.11 1 11.5 2.73 15.89 7 19 12 19s9.27-3.11 11-7.5C21.27 7.11 17 4 12 4m0 5c1.38 0 2.5 1.12 2.5 2.5S13.38 14 12 14s-2.5-1.12-2.5-2.5S10.62 9 12 9m0-2c-2.48 0-4.5 2.02-4.5 4.5S9.52 16 12 16s4.5-2.02 4.5-4.5S14.48 7 12 7">
								</path>
							</svg> -->
							<svg v-if="!showPassword" xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 0 24 24" width="24px" fill="#5f6368"><path d="M0 0h24v24H0V0zm0 0h24v24H0V0zm0 0h24v24H0V0zm0 0h24v24H0V0z" fill="none"/><path d="M12 6c3.79 0 7.17 2.13 8.82 5.5-.59 1.22-1.42 2.27-2.41 3.12l1.41 1.41c1.39-1.23 2.49-2.77 3.18-4.53C21.27 7.11 17 4 12 4c-1.27 0-2.49.2-3.64.57l1.65 1.65C10.66 6.09 11.32 6 12 6zm-1.07 1.14L13 9.21c.57.25 1.03.71 1.28 1.28l2.07 2.07c.08-.34.14-.7.14-1.07C16.5 9.01 14.48 7 12 7c-.37 0-.72.05-1.07.14zM2.01 3.87l2.68 2.68C3.06 7.83 1.77 9.53 1 11.5 2.73 15.89 7 19 12 19c1.52 0 2.98-.29 4.32-.82l3.42 3.42 1.41-1.41L3.42 2.45 2.01 3.87zm7.5 7.5l2.61 2.61c-.04.01-.08.02-.12.02-1.38 0-2.5-1.12-2.5-2.5 0-.05.01-.08.01-.13zm-3.4-3.4l1.75 1.75c-.23.55-.36 1.15-.36 1.78 0 2.48 2.02 4.5 4.5 4.5.63 0 1.23-.13 1.77-.36l.98.98c-.88.24-1.8.38-2.75.38-3.79 0-7.17-2.13-8.82-5.5.7-1.43 1.72-2.61 2.93-3.53z"/></svg>
							<svg v-else xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 0 24 24" width="24px" fill="#5f6368"><path d="M0 0h24v24H0V0z" fill="none"/><path d="M12 6c3.79 0 7.17 2.13 8.82 5.5C19.17 14.87 15.79 17 12 17s-7.17-2.13-8.82-5.5C4.83 8.13 8.21 6 12 6m0-2C7 4 2.73 7.11 1 11.5 2.73 15.89 7 19 12 19s9.27-3.11 11-7.5C21.27 7.11 17 4 12 4zm0 5c1.38 0 2.5 1.12 2.5 2.5S13.38 14 12 14s-2.5-1.12-2.5-2.5S10.62 9 12 9m0-2c-2.48 0-4.5 2.02-4.5 4.5S9.52 16 12 16s4.5-2.02 4.5-4.5S14.48 7 12 7z"/></svg>
						</button>
					</div>
					
				</div>


				<div class="_passwordValidators_1n6c7_12">
					<div class="_passwordValidator_lqpo0_1">
						<div class="_passwordValidatorSvg_lqpo0_15">
							<svg width="17" height="17" viewBox="0 0 17 17" fill="none" xmlns="http://www.w3.org/2000/svg">
								<rect x="0.25" y="0.5" width="16" height="16" rx="8" fill="#ECECEC"></rect>
								<path d="M11.5832 6L6.99984 10.5833L4.9165 8.5" :stroke="passIsOver8Digits ? '#43A047' : '#A3A3A3'"
								stroke-width="0.833333" stroke-linecap="round" stroke-linejoin="round"></path>
							</svg>
						</div>
						<span :style="{color: passIsOver8Digits ? '#43A047' : '#A3A3A3'}">8 תווים לפחות</span>
					</div>
					<div class="_passwordValidator_lqpo0_1">
						<div class="_passwordValidatorSvg_lqpo0_15">
							<svg width="17" height="17" viewBox="0 0 17 17" fill="none" xmlns="http://www.w3.org/2000/svg">
								<rect x="0.25" y="0.5" width="16" height="16" rx="8" fill="#ECECEC"></rect>
								<path d="M11.5832 6L6.99984 10.5833L4.9165 8.5" :stroke="passIsLettersAndNumbers ? '#43A047' : '#A3A3A3'"
								stroke-width="0.833333" stroke-linecap="round" stroke-linejoin="round"></path>
							</svg>
						</div>
						<span  :style="{color: passIsLettersAndNumbers ? '#43A047' : '#A3A3A3'}">אותיות ומספרים</span>
					
					</div>
					<div class="_passwordValidator_lqpo0_1">
						<div class="_passwordValidatorSvg_lqpo0_15">
							<svg width="17" height="17" viewBox="0 0 17 17" fill="none" xmlns="http://www.w3.org/2000/svg">
								<rect x="0.25" y="0.5" width="16" height="16" rx="8" fill="#ECECEC" ></rect>
								<path d="M11.5832 6L6.99984 10.5833L4.9165 8.5" :stroke="passIsEnglish ? '#43A047' : '#A3A3A3'"
								stroke-width="0.833333" stroke-linecap="round" stroke-linejoin="round"></path>
							</svg>
						</div>
						<span  :style="{color: passIsEnglish ? '#43A047' : '#A3A3A3'}"
						>אנגלית בלבד</span>
					</div>
				</div>
	
				<div class="inputContainer">
					<input
						v-model="passwordAgain"
						name="passwordAgain"
						class="genericInput"
						:type="showPasswordValidate ? 'text' : 'password'"
						autocomplete="on"
						maxlength="20"
						placeholder="אימות סיסמה"
						value=""
					/><button class="editBtn"></button>
					<div class="button-container infoBtn"  style="left: 10px;">
						<button @click="toggleShowPasswordValidate()">	
							<!-- <svg class="MuiSvgIcon-root MuiSvgIcon-fontSizeMedium muirtl-wti7xm" focusable="false" aria-hidden="true" viewBox="0 0 24 24"  height="20px"      color="red"
							data-testid="VisibilityOutlinedIcon">
								<path d="M12 6c3.79 0 7.17 2.13 8.82 5.5C19.17 14.87 15.79 17 12 17s-7.17-2.13-8.82-5.5C4.83 8.13 8.21 6 12 6m0-2C7 4 2.73 7.11 1 11.5 2.73 15.89 7 19 12 19s9.27-3.11 11-7.5C21.27 7.11 17 4 12 4m0 5c1.38 0 2.5 1.12 2.5 2.5S13.38 14 12 14s-2.5-1.12-2.5-2.5S10.62 9 12 9m0-2c-2.48 0-4.5 2.02-4.5 4.5S9.52 16 12 16s4.5-2.02 4.5-4.5S14.48 7 12 7">
								</path>
							</svg> -->
							<svg v-if="!showPasswordValidate" xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 0 24 24" width="24px" fill="#5f6368"><path d="M0 0h24v24H0V0zm0 0h24v24H0V0zm0 0h24v24H0V0zm0 0h24v24H0V0z" fill="none"/><path d="M12 6c3.79 0 7.17 2.13 8.82 5.5-.59 1.22-1.42 2.27-2.41 3.12l1.41 1.41c1.39-1.23 2.49-2.77 3.18-4.53C21.27 7.11 17 4 12 4c-1.27 0-2.49.2-3.64.57l1.65 1.65C10.66 6.09 11.32 6 12 6zm-1.07 1.14L13 9.21c.57.25 1.03.71 1.28 1.28l2.07 2.07c.08-.34.14-.7.14-1.07C16.5 9.01 14.48 7 12 7c-.37 0-.72.05-1.07.14zM2.01 3.87l2.68 2.68C3.06 7.83 1.77 9.53 1 11.5 2.73 15.89 7 19 12 19c1.52 0 2.98-.29 4.32-.82l3.42 3.42 1.41-1.41L3.42 2.45 2.01 3.87zm7.5 7.5l2.61 2.61c-.04.01-.08.02-.12.02-1.38 0-2.5-1.12-2.5-2.5 0-.05.01-.08.01-.13zm-3.4-3.4l1.75 1.75c-.23.55-.36 1.15-.36 1.78 0 2.48 2.02 4.5 4.5 4.5.63 0 1.23-.13 1.77-.36l.98.98c-.88.24-1.8.38-2.75.38-3.79 0-7.17-2.13-8.82-5.5.7-1.43 1.72-2.61 2.93-3.53z"/></svg>
							<svg v-else xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 0 24 24" width="24px" fill="#5f6368"><path d="M0 0h24v24H0V0z" fill="none"/><path d="M12 6c3.79 0 7.17 2.13 8.82 5.5C19.17 14.87 15.79 17 12 17s-7.17-2.13-8.82-5.5C4.83 8.13 8.21 6 12 6m0-2C7 4 2.73 7.11 1 11.5 2.73 15.89 7 19 12 19s9.27-3.11 11-7.5C21.27 7.11 17 4 12 4zm0 5c1.38 0 2.5 1.12 2.5 2.5S13.38 14 12 14s-2.5-1.12-2.5-2.5S10.62 9 12 9m0-2c-2.48 0-4.5 2.02-4.5 4.5S9.52 16 12 16s4.5-2.02 4.5-4.5S14.48 7 12 7z"/></svg>
						</button>
					</div>
				</div>
				<p v-show="isError == true && !notValid" style="color: red" class="plainText">
					{{ errorText }}
				</p>
				<p v-show="errorUserText != null" style="color: red" class="plainText">
					{{ errorUserText }}
				</p>
				<div class="inputContainer checkboxContainer">
					<input
						v-model="termsOfService"
						name="termsOfService"
						class="checkbox"
						type="checkbox"
					/><span class="checkmark"></span
					><label class="checkboxLabel"
						
						>קראתי ואישרתי את<a
							class="link linkUnderline"
							rel="noreferrer"
							href="/?view=termofuse"
							>תנאי השימוש</a
						></label
					>
				</div>
				<button :disabled="notValid" @click="signIn()" class="btn blue">
					אישור חשבון
				</button>
				<a class="link linkUnderline" href="/?view=login"
					>רשומים כבר? הכנסו עכשיו</a
				>
			</div>

			<div v-if="iconCircleLocation">
				<p>Left: {{ iconCircleLocation.left }}</p>
				<p>Right: {{ iconCircleLocation.right }}</p>
				<p>Top: {{ iconCircleLocation.top }}</p>
				<p>Bottom: {{ iconCircleLocation.bottom }}</p>
			</div>
		</div>

		
	</div>
</template>

<script src="https://www.google.com/recaptcha/enterprise.js?render=6LdJAz4qAAAAAGnDqX4rT9kMeQSWngUOsYTHOtNT"></script>

<script>

export default {
	data() {
		return {
			showDiv: false,
			firstName: "",
			lastName: "",
			emailAddress: "",
			password: "",
			passwordAgain: "",
			termsOfService: false,
			isError: false,
			userExists: false,
			errorUserText: null,
			iconCircleLocation: null,
			popoverStyle: {},
			isLoading: true,  // Initial state to show the loading message
			recaptchaToken: '', // Store the reCAPTCHA token here
			showPassword: false,
			showPasswordValidate: false,
		};
	},
	computed: {
		passIsOver8Digits() {
			return this.password.length >= 8;
		},
		passIsLettersAndNumbers() {
			if (!this.password) {
				return false;
			}
			return /[a-zA-Z]/.test(this.password) && /[0-9]/.test(this.password);
		},
		passIsEnglish() {
			// if is null... return false
			if (!this.password) {
				return false;
			}
			// allow '?' and '!' and '@' and '#' and '$' and '%' and '^' and '&' and '*' and '(' and ')' and '-' and '_' and '=' and '+' and '[' and ']' and '{' and '}' and '|' and ';' and ':' and '"' and ',' and '.' and '/' and '>'
			//return /^[a-zA-Z0-9]*$/.test(this.password);
			return /^[a-zA-Z0-9!@#$%^&*()\-_=+\[\]{}|;:'",.<>/?]*$/.test(this.password);
		},
		getStyle() {
			if (!this.iconCircleLocation) {
				return "";
			}
			return {
				position: 'absolute',
				inset: 'auto auto 0px 0px',
				margin: '0px',
				transform: `translate(${this.iconCircleLocation.left}px, ${this.iconCircleLocation.top}px)`
			};
		},
		errorText() {
			if (!this.firstName) {
				return "נא להזין שם פרטי";
			} else if (!this.lastName) {
				return "נא להזין שם משפחה";
			}
			if (
				!this.emailAddress ||
				!this.emailAddress.includes("@") ||
				!this.emailAddress.includes(".")
			) {
				return "נא להזין כתובת מייל";
			} else if (!this.password) {
				return "נא להזין סיסמה";
			} else if (!this.passwordAgain) {
				return "נא להזין את הסיסמה בשנית";
			} else if (this.password != this.passwordAgain) {
				return "הסיסמאות אינן תואמות";
			} else if (this.password.length < 8) {
				return "הסיסמה חייבת להיות באורך של לפחות 8 תווים";
			} else if (
				!(this.password.match(/[a-z]/) ||
				this.password.match(/[A-Z]/)) ||
				!this.password.match(/[0-9]/)
			) {
				return "הסיסמה חייבת להכיל לפחות אות אחת ומספר אחד";
			} else if (!this.termsOfService) {
				return "נא לאשר את מדיניות הפרטיות ואת תנאי השימוש";
			} else if (this.userExists) {
				return "המייל קיים במערכת";
			} else {
				return "";
			}
		},
		notValid() {
			if (
				this.firstName &&
				this.lastName &&
				this.emailAddress &&
				this.password &&
				this.passwordAgain &&
				this.termsOfService &&
				this.passIsOver8Digits &&
				this.passIsLettersAndNumbers &&
				this.passIsEnglish &&
				!this.UserExists
			) {
				return false;
			} else {
				return true;
			}
		},
	},
	methods: {
		toggleShowPassword(){
			this.showPassword = !this.showPassword;
		},
		toggleShowPasswordValidate(){
			this.showPasswordValidate = !this.showPasswordValidate;
		},
		loadRecaptchaScript() {
			// Check if the reCAPTCHA script is already added to avoid multiple loads
			if (!document.getElementById('recaptcha-script')) {
				const script = document.createElement('script');
				script.src = 'https://www.google.com/recaptcha/enterprise.js?render=6LdJAz4qAAAAAGnDqX4rT9kMeQSWngUOsYTHOtNT';
				script.id = 'recaptcha-script';
				script.onload = this.onRecaptchaScriptLoaded;
				document.head.appendChild(script);
			} else {
				this.onRecaptchaScriptLoaded(); // Script already loaded, proceed
			}
		},
		onRecaptchaScriptLoaded() {
			// Once the script is loaded, initialize reCAPTCHA
			grecaptcha.enterprise.ready(() => {
				grecaptcha.enterprise
				.execute('6LdJAz4qAAAAAGnDqX4rT9kMeQSWngUOsYTHOtNT', { action: 'PAGE_LOAD' })
				.then((token) => {
					// Token available for any further use
					this.$store.state.recaptchaToken = token;
				});
			});
		},
		refreshRecaptcha() {
			grecaptcha.enterprise.ready(() => {
				grecaptcha.enterprise
				.execute('6LdJAz4qAAAAAGnDqX4rT9kMeQSWngUOsYTHOtNT', { action: 'PAGE_LOAD' })
				.then((token) => {
					// Token available for any further use
					this.$store.state.recaptchaToken = token;
				});
			});
		},
		
		async signIn() {
			try {
				// Reset error states
				this.errorUserText = "";
				this.isError = false;
				
				// Validate input
				if (this.notValid) {
					return;
				}

				if (this.errorText) {
					this.isError = true;
					return;
				}

				// Update store state
				this.$store.state.useremail = this.emailAddress;
				this.$store.state.password = this.password;

				// Clear existing cookies
				this.mixin_removeCookie('useremail');
				//this.mixin_removeCookie("pwd");
				this.mixin_removeCookie('userTokenType');
				this.mixin_removeCookie('user');

				// Set email in cookie
				this.mixin_setCookie('useremail', this.emailAddress);

				// Create full name
				const fullName = `${this.firstName} ${this.lastName}`;

				// Create user
				// Before sending, Encryption of password + emailAddress
				//clear session storage
				sessionStorage.clear();
				const user_res = await this.mixin_createUser(
					this,
					fullName,
					this.emailAddress,
					this.password,
					this.$store.state.recaptchaToken
				);

				// Handle response based on status code
				switch (user_res.statusCode) {
					case 200:
						// Successful creation
						this.$store.state.userid = user_res.data.userID;
						this.$store.state.useremail = this.emailAddress;
						this.$store.state.username = fullName;

						// Store user data in cookies
						//this.mixin_setCookie("pwd", this.password);
						var obj = {
							"pwd": this.password
						}
						//compress
						var compressed = this.compressBase64Gzip(JSON.stringify(obj));
						this.mixin_setCookie('up', compressed);
						var user = {
							addressList: user_res.data.addresses,
							userid: user_res.data.userID,
							useremail: this.emailAddress,
							username: fullName,
							Verified: false,
						};
						// compress and set user data in cookie
						var compressed = this.compressBase64Gzip(JSON.stringify(user));
						
						this.mixin_setCookie('user', compressed);

						// Set token type
						this.$store.state.userTokenType = "verif";
						this.mixin_setCookie('userTokenType', "verif");

						// Navigate to approval page
						this.mixin_goTo(this, "approve");
						break;

					case 400:
						// Bad request
						this.handleError(
							user_res.data.message || "שגיאה ביצירת משתמש",
							"validation"
						);
						break;

					case 500:
						// Server error
						this.handleError("שגיאה בצד שרת", "server");
						break;

					default:
						// Unknown error
						this.handleError("שגיאה ביצירת משתמש", "unknown");
						break;
				}
			} catch (error) {
				console.error("Error creating user:", error);
				this.handleError("שגיאה ביצירת משתמש", "system");
			} finally {
				// Always refresh reCAPTCHA if there was an error
				if (this.isError) {
					this.refreshRecaptcha();
				}
			}
		},
		// Helper method to handle errors
		handleError(message, type) {
			this.isError = true;
			//this.notValid = true;
			this.errorUserText = message;
			
			// Log error details
			console.error("User creation error:", {
				type,
				message,
				timestamp: new Date().toISOString()
			});
		},

		// Additional helper to validate user input (optional)
		validateInput() {
			const errors = [];
			
			if (!this.emailAddress) {
				errors.push("Email is required");
			}
			
			if (!this.password) {
				errors.push("Password is required");
			}
			
			if (!this.firstName || !this.lastName) {
				errors.push("Full name is required");
			}
			
			if (errors.length > 0) {
				this.errorUserText = errors.join(", ");
				this.isError = true;
				this.notValid = true;
				return false;
			}
			
			return true;
		},
		updateIconCircleLocation() {
			if (!this.$refs.iconCircle) {
				return;
			}
			const iconCircle = this.$refs.iconCircle;
			if (iconCircle) {
				const rect = iconCircle.getBoundingClientRect();
				this.iconCircleLocation = {
				left: rect.left,
				right: rect.right,
				top: rect.top,
				bottom: rect.bottom
				};
			}
		},
	},
	mounted() {
		this.loadRecaptchaScript();
		this.updateIconCircleLocation();
		window.addEventListener('resize', this.updateIconCircleLocation); // Update on resize

	},
	beforeDestroy() {
		window.removeEventListener('resize', this.updateIconCircleLocation);
	},
};
</script>


<style scoped>

._passwordValidators_1n6c7_12 {
    display: flex;
    gap: 1rem;
   
}

._passwordValidator_lqpo0_1 {
    display: flex;
    align-items: center;
    gap: .3rem;
}

.button-container {
	position: relative;
	width: 23px;
}

._passwordValidatorSvg_lqpo0_15 {
    color: transparent;

}

._notValid_lqpo0_11 {
    color: var(--white-900);
}



@media screen and (max-width: 768px) {
    .formContainer {
        gap: 0px;
    }
}
.popup { 

	user-select: none;
	-webkit-user-select: none;
	-moz-user-select: none;
	-ms-user-select: none;
	position: absolute;
	bottom: 100%; /* Changed from top to bottom */
	left: 50%;
	transform: translateX(-50%);
	margin-bottom: 10px; /* Changed from margin-top */
	padding: 10px;
	background-color:white;
	border-radius: 5px;
	box-shadow: 0 -4px 6px rgba(0, 0, 0, 0.1); /* Changed shadow direction */
	opacity: 1;

	transition: opacity 0.3s ease, visibility 0.3s ease;
	width: 140px;
	font-size: 1.1em;
    line-height: 1.57;
	box-shadow: 0 1px 11px 4px rgba(0, 0, 0, .18);
}


.popup::after { /* Changed from ::before to ::after */

	content: '';
	position: absolute;
	top: 100%; /* Changed from bottom to top */
	left: 50%;
	border: 8px solid transparent;
	border-top-color:white; /* Changed from border-bottom-color */
	transform: translateX(-50%);
}

@media screen and (max-width: 600px) {
	.popup {
		left: 60px;
	}
	.popup::after {
		left: 25px;
	}

}

</style>
